<div class="board-wrapper">
    <div class="sudoku-board">
        <div *ngFor="let row of board; let i = index" class="row">
        <input
            *ngFor="let cell of row; let j = index"
            class="cell"
            [ngClass]="{
            'readonly': cell.readonly,
            'invalid': cell.invalid,
            'highlight': isHighlighted(cell) && !cell.invalid,
            }"
            [readOnly]="cell.readonly"
            [value]="cell.value ?? ''"
            (input)="updateCell(i, j, $event.target.value)"
            (keydown)="handleKeyDown($event, i, j)"
            [attr.id]="'cell-' + i + '-' + j"
            (focus)="handleFocus($event, i, j)"
            (mousedown)="onCellSelect(i, j)"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            inputmode='none'
        />
        </div>
    </div>
</div>
<div class="numbers">
    <button class="number" *ngFor="let n of [1,2,3,4,5,6,7,8,9]" (click)="selectNumber(n)">{{ n }}</button>
    <button class="number" (click)="clearCell()">X</button>
</div>
<div class="timer">⏱ {{ timerDisplay }}</div>  
<div class="controls">
    <label>
      Difficulty:
      <select [(ngModel)]="difficulty">
        <option value="easy">Easy</option>
        <option value="medium">Medium</option>
        <option value="hard">Hard</option>
      </select>
    </label>
  
    <button (click)="resetGame()">New Puzzle</button>
  
    <div *ngIf="solved" class="success">🎉 Puzzle Solved!</div>
</div>
<div class="highscores-wrapper">
    <table class="highscores" *ngIf="solved">
        <tr><th colspan="3">Highscores</th></tr>
        <tr>
            <th>Name</th><th>Time</th><th>Date</th>
        </tr>
        <ng-container *ngFor="let score of topScores">
            <tr *ngIf="score.score < timer">
                <td>{{ score.user }}</td><td>{{ score.score }}</td><td>{{ score.created_at | date:'yyyy-MM-dd' }}</td>
            </tr>
        </ng-container>
        <tr>
            <td></td><td>{{ timer }}</td><td></td>
        </tr>
        <ng-container *ngFor="let score of topScores">
            <tr *ngIf="score.score >= timer">
                <td>{{ score.user }}</td><td>{{ score.score }}</td><td>({{ score.created_at | date:'yyyy-MM-dd' }})</td>
            </tr>
        </ng-container>
    </table>
</div>
